import { render, staticRenderFns } from "./medical-documents-create-edit-modal.vue?vue&type=template&id=4df3a671&scoped=true&"
import script from "./medical-documents-create-edit-modal.vue?vue&type=script&lang=js&"
export * from "./medical-documents-create-edit-modal.vue?vue&type=script&lang=js&"
import style0 from "./medical-documents-create-edit-modal.vue?vue&type=style&index=0&id=4df3a671&lang=scss&scoped=true&"
import style1 from "./medical-documents-create-edit-modal.vue?vue&type=style&index=1&id=4df3a671&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df3a671",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4df3a671')) {
      api.createRecord('4df3a671', component.options)
    } else {
      api.reload('4df3a671', component.options)
    }
    module.hot.accept("./medical-documents-create-edit-modal.vue?vue&type=template&id=4df3a671&scoped=true&", function () {
      api.rerender('4df3a671', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personal-employee/additions/modals/medical-documents-create-edit-modal.vue"
export default component.exports